
import React, { Component, Fragment } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row } from 'reactstrap';
import moment from 'moment';
import * as firebase from 'firebase';
import defaultUserAvatar from 'assets/images/athena/user.png';

class UserInspector extends Component {
  constructor(props, context) {
    super(props, context);

    this.toggle = this.toggle.bind(this);

    this.state = {
      activeTab: '1',
      loading: true,
      user: {
        "acceptedTerms" : 1544608891870,
        "defaultPaymentMethodId" : "card_1DgUXlJoOUBfCaOsMxb58qGx",
        "deviceTokens" : {
          "c4Pki-V0mn8:APA91bHYi82gn-wYatQ7zfScOlPJfghUoRVDtg1Qm9AdCloVtMRji6v2V52GgH-FmDV_lAu-B5wYIx0s-0YX2FnJU2vyXvL_ZRIxpWFkMqpe0ZR_jc87k6_GJLKr6l6W3QXSgwh8aMzS" : "c4Pki-V0mn8:APA91bHYi82gn-wYatQ7zfScOlPJfghUoRVDtg1Qm9AdCloVtMRji6v2V52GgH-FmDV_lAu-B5wYIx0s-0YX2FnJU2vyXvL_ZRIxpWFkMqpe0ZR_jc87k6_GJLKr6l6W3QXSgwh8aMzS",
          "cIw72NWOX8k:APA91bF3tebAQEP6dGaMADd6EM1Wsm5uY44oBIpNNTbzmjRUUMLxrEOkwCPePY4XOMn6zmKmN8PDXrnhgTm9h-A19lgXKxGU_o58FvwEuvIWzZVMcE-vOpiHBUlXZnaYAksxjsKh9GMp" : "cIw72NWOX8k:APA91bF3tebAQEP6dGaMADd6EM1Wsm5uY44oBIpNNTbzmjRUUMLxrEOkwCPePY4XOMn6zmKmN8PDXrnhgTm9h-A19lgXKxGU_o58FvwEuvIWzZVMcE-vOpiHBUlXZnaYAksxjsKh9GMp"
        },
        "email" : "patrick@bambooapp.ie",
        "name" : "Patrick O'Boyle",
        "paymentMethods" : {
          "card_1DgUXlJoOUBfCaOsMxb58qGx" : {
            "cardType" : "Visa",
            "created" : 1544608940716,
            "cvcCheck" : "pass",
            "default" : true,
            "expirationDate" : "6/2022",
            "expirationMonth" : 6,
            "expirationYear" : 2022,
            "fundingType" : "debit",
            "lastFour" : "8402",
            "token" : "card_1DgUXlJoOUBfCaOsMxb58qGx"
          }
        },
        "invalidVouchers": {},
        "vouchers": {},
        "properties" : {
          "averageSpend" : 661.2751879699248,
          "firstOrderedAt" : 1492685065477,
          "hasCard" : true,
          "lastOrderedAt" : 1569586779596,
          "lastViewedMenuId" : "-LC-SnOdWVyMEkHqnRjP",
          "lastViewedMenuMoment" : 1569605720198,
          "totalOrderNumber" : 665,
          "totalOrdersPerMerchant" : {
            "-KaNso8gAa2QA80e6kb5" : 4,
            "-KaNweJ8zAVao0ioe0hz" : 4,
            "-Kdc-rBXsEr7NDdShgJ1" : 4,
            "-KgyiYQRWiIliI20gRHj" : 395,
            "-Kh3MpWuzIWwZDE6AmU-" : 1,
            "-KlDqhKmeDNahQ1VaXW_" : 1,
            "-Kr-uvoJ9XfKXTx1UVTl" : 7,
            "-Kr2kOwc4AT2kkr8ZXo_" : 1,
            "-KupdEeb4bpFtRSH55lo" : 3,
            "-Kx93rujlo3OjA9wDoVK" : 1,
            "-KyMnu7c476Nkxu-81GW" : 1,
            "-KyoXevrVA3eafz2TrVi" : 46,
            "-LA-5fd078tqZxJYMtZZ" : 3,
            "-LA9TxiKYJbEqVZCTUqd" : 6,
            "-LAJOOAseNWG4dRJK79l" : 1,
            "-LAmelBfjLVpNu7DwZzL" : 4,
            "-LB1uwprX-HwSlED8Y_L" : 1,
            "-LBRYtUISxuIL3qlktxL" : 51,
            "-LChObiL4VMJCJqRM8_S" : 1,
            "-LDH6hb59Cl5zV3t1ec_" : 1,
            "-LEsNYEB6CoyvqAZjpZB" : 1,
            "-LFqRy0m6s2tA458gycy" : 62,
            "-LGPBm7CXf3ZuCBoLxLn" : 1,
            "-LGzj4W9nhPmwUcXni2Z" : 1,
            "-LKfNJ6GXUjD16dwX_Is" : 2,
            "-LM2sCujvvoD4ra5Uzro" : 1,
            "-LNM6mb9OnaXBW3QRejM" : 1,
            "-LNjqHicse8cvc80vmkQ" : 1,
            "-LOSE-ukzXhwCsS8R3YW" : 1,
            "-LSFb4vST4tznBL8Ch-Z" : 2,
            "-LSJspYivTAyLvWqC4wL" : 1,
            "-LSL7XbhOoqD-Wy2-k8x" : 1,
            "-LSumOekNI-BThP_NNP8" : 1,
            "-LZt3xTGN3INie9DY9W0" : 2,
            "-LdmI5zINBtE9xPNpJTU" : 6,
            "-LeMnfKrL8o4KS6FBrYw" : 1,
            "-LeRdBkSJ2xWHJCZyVia" : 18,
            "-Lftdoy9duLpOdkPMx00" : 1,
            "-LhdrXtIqqeNoWizNyQf" : 11,
            "-LhdyzijpO2g-XoH6xCp" : 1,
            "-LlS3JWiaBKeFOUwRA-D" : 2,
            "-Lp7zWRtFvlvbWZOcfC8" : 7,
            "storeUid3" : 4
          },
          "totalSpend" : 439748
        },
        "phoneNumber" : {
          "isVerified" : true,
          "phoneNumber" : "3530000000000",
          "verifiedTime" : 1558096620123
        },
        "referral" : {
          "campaignId" : "Refer_A_Friend_v4",
          "campaignVersion" : 4,
          "deeplink" : "https://bamboo.page.link/kqzE",
          "voucher" : {
            "active" : true,
            "campaign" : "Refer_A_Friend_v4",
            "discount" : {
              "amountOff" : 500,
              "type" : "AMOUNT"
            },
            "startDate" : 1560812400000,
            "type" : "DISCOUNT_VOUCHER"
          },
          "voucherId" : "BAMQTLNB"
        },
      },
    }
  }

  async componentDidMount() {
    document.title = "User | Athena";

    const userId = this.props.match.params.userId;
    const user = (await firebase.database().ref('/users/' + userId).once('value')).val();

    const userIdentifier = user.name || user.email;
    
    document.title = `${userIdentifier} | Athena`;

    console.log(user);
    this.setState({ user, userId, loading: false, deleted: user.deleted, vouchersAreDisabled: user.vouchersAreDisabled});
  }

  toggleVouchersDisabled = async () => {
    const newValue = !this.state.vouchersAreDisabled;
    this.setState({ vouchersAreDisabled: newValue });
    const userId = this.props.match.params.userId;
    await firebase.database().ref(`/users/${userId}/vouchersAreDisabled`).set(newValue);
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  formatDateTime (date) {
    if(date){
      return moment(date).format("h:mma, D MMM YYYY")
    } else {
      return '-'
    }
  }

  render() {
    let user = this.state.user;
    let invalidVouchers = [];
    if(user && user.invalidVouchers) {
      for (let [voucherId, voucherObj] of Object.entries(user.invalidVouchers)) {
        invalidVouchers.push(
          <tr>
            <th>{voucherId}</th>

            {
              voucherObj.discount
                ? <td>{"€" + voucherObj.discount.amountOff / 100}</td>
                : <td>{"€" + (voucherObj.gift.amount - voucherObj.gift.balance) / 100} / {"€" + voucherObj.gift.amount / 100}</td>
            }
          </tr>
        );
      }
    }

    let activeVouchers = [];
    if(user && user.vouchers) {
      for (let [voucherId, voucherObj] of Object.entries(user.vouchers)) {
        activeVouchers.push(
          <tr>
            <th>{voucherId}</th>
            {
              voucherObj.discount
                ? <td>{"€" + voucherObj.discount.amountOff / 100}</td>
                : <td>{"€" + (voucherObj.gift.amount - voucherObj.gift.balance) / 100} / {"€" + voucherObj.gift.amount / 100}</td>
            }
          </tr>
        );
      }
    }

    let cards = [];
    if(user && user.paymentMethods) {
      for (let [paymentMethodId, paymentMethod] of Object.entries(user.paymentMethods)) {
        cards.push(
          <tr>
            <th>{paymentMethod.cardType}</th>
            <td>
              <ul>
                <li>Added: {this.formatDateTime(paymentMethod.created)}</li>
                <li>Expires: {paymentMethod.expirationDate}</li>
                <li>Funding type: {paymentMethod.fundingType}</li>
                <li>Last 4 digits: {paymentMethod.lastFour}</li>
                <li>User's default: {paymentMethod.default ? "Yes" : "No"}</li>
                <li>Payment Method ID: {paymentMethodId}</li>

              </ul>
            </td>
          </tr>
        );
      }
    }

    let storeOrderNumbers = []
    if(user && user.properties && user.properties.totalOrdersPerMerchant) {
      for (let [merchantId, numOrders] of Object.entries(user.properties.totalOrdersPerMerchant)) {
        storeOrderNumbers.push(
          <tr>
            <th>
              <a href={"https://admin.bambooapp.ie/admin/edit_merchant.html?id=" + merchantId} target="_blank" rel="noopener noreferrer">{merchantId}</a>
            </th>
            <td>{numOrders}</td>
          </tr>
        );
      }
    }

    let connections = [];
    let userConnnections = user && user.connections;
    if(userConnnections) {
      userConnnections.forEach( (connection) => {
        connections.push(
          <tr>
            <div>
                <a href={"/admin/user/" + connection.userId} target="_blank" rel="noopener noreferrer">
                  <img alt="Connection" src={connection.photoUrl || defaultUserAvatar} className="connection-img"/>
                  {connection.name}
              </a>
            </div>
          </tr>
        );
      });
    }

    const deletedUserProfile = (
      <div className="col-md-10 offset-md-1 card">
        <h2>User account has been deleted</h2>
      </div>
    );

    const voucherToggle = (
      <div className="col-md-12">
        <button className="btn btn-primary" onClick={this.toggleVouchersDisabled}>
          {this.state.vouchersAreDisabled ? "Enable vouchers" : "Disable vouchers"}
        </button>
      </div>
    );

    const userProfile = (
      <div className="col-md-10 offset-md-1 card">
        <div className="row no-gutters">
          <div className="col-md-4 user-left pt-4 pb-4">
              <Row>
                <div className="col-md-5 text-center">
                  <img alt="User" src={user.photoUrl || defaultUserAvatar} className="profile-pic" />
                </div>

                <div className="col-md-6">
                  <h3>{ user.name }</h3>
                </div>
              </Row>

              <br/>

              <div className="col-md-12">    
                <p>Bamboo ID: { this.state.userId || "-"}</p>
              </div>

              <div className="col-md-12">
                <p>Vouchers disabled: { this.state.vouchersAreDisabled ? "Yes" : "No" }</p>
              </div>

              {
                user.marketingConsent
                  ? 
                    <div className="col-md-12">
                      <p>Opt in to marketing: { user.marketingConsent.consented ? "Yes" : "No" }</p>
                    </div>
                  : ""
              }

              <br/>

              <div className="col-md-12">
                  <a className="btn btn-primary" href={"https://dashboard.stripe.com/customers/" + user.stripeCustomerId} target="_blank" rel="noopener noreferrer">
                    View in Stripe
                  </a>
              </div>

              <br/>

              { voucherToggle }

              <br />
          </div>


          <div className="col-md-8">
            <Nav tabs className="pt-2">
              <NavItem>
                <NavLink
                  className={({ active: this.state.activeTab === '1' })}
                  onClick={() => { this.toggle('1'); }}
                >
                  Account info
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={({ active: this.state.activeTab === '2' })}
                  onClick={() => { this.toggle('2'); }}
                >
                  Cards
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={({ active: this.state.activeTab === '3' })}
                  onClick={() => { this.toggle('3'); }}
                >
                  Invalid Vouchers
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={({ active: this.state.activeTab === '4' })}
                  onClick={() => { this.toggle('4'); }}
                >
                  Store Orders
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={({ active: this.state.activeTab === '5' })}
                  onClick={() => { this.toggle('5'); }}
                >
                  Referral Info
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={({ active: this.state.activeTab === '6' })}
                  onClick={() => { this.toggle('6'); }}
                >
                  Active Vouchers
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={({ active: this.state.activeTab === '7' })}
                  onClick={() => { this.toggle('7'); }}
                >
                  Connections
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="1">
                <table className="table">
                  <tbody>
                    <tr>
                      <th>Email:</th>
                      <td>
                        {user.email || "-"}
                      </td>
                    </tr>

                    <tr>
                      <th>Phone number:</th>
                      <td>
                        { 
                          user.phoneNumber
                          ? "+" + user.phoneNumber.phoneNumber
                          : "-"
                        }
                      </td>
                    </tr>
                    
                    { 
                        user.phoneNumber
                        ?
                          <tr>
                            <th>Phone verified at:</th>
                            <td>
                              { this.formatDateTime(user.phoneNumber.verifiedTime) + " UTC" || "-" }
                            </td>
                          </tr>
                        : ""
                    }

                    <tr>
                      <th>First ordered:</th>
                      <td>
                        { this.formatDateTime(user.properties && user.properties.firstOrderedAt) }
                      </td>
                    </tr>

                    <tr>
                      <th>Latest ordered:</th>
                      <td>
                        { this.formatDateTime(user.properties && user.properties.lastOrderedAt) }
                      </td>
                    </tr>

                    <tr>
                      <th>Has a card:</th>
                      <td>
                        { user.properties && user.properties.hasCard ? "Yes" : "No" }
                      </td>
                    </tr>

                    <tr>
                      <th>Last viewed a menu:</th>
                      <td>
                        { this.formatDateTime(user.properties && user.properties.lastViewedMenuMoment) }
                      </td>
                    </tr>

                    <tr>
                      <th>Average Spend:</th>
                      <td>
                        €{ (user.properties && (user.properties.averageSpend / 100).toFixed(2)) || "-" }
                      </td>
                    </tr>

                    <tr>
                      <th>Total no. orders:</th>
                      <td>
                        { (user.properties && user.properties.totalOrderNumber) || "-" }
                      </td>
                    </tr>

                    <tr>
                      <th>Total Spend:</th>
                      <td>
                        € { user.properties && (user.properties.totalSpend / 100).toFixed(2) }
                      </td>
                    </tr>

                    <tr>
                      <th>Business user:</th>
                      <td>
                      { user.businessId ? "Yes" : "No" }
                      </td>
                    </tr>

                    {
                      user.businessId
                        ?
                          <tr>
                            <th>Business ID:</th>
                            <td>
                              { user.businessId }
                            </td>
                          </tr>
                        : ""
                    }
                  </tbody>
                </table>
              </TabPane>
              <TabPane tabId="2">
                <table className="table">
                  <tbody>
                    { cards }
                  </tbody>
                </table>
              </TabPane>
              <TabPane tabId="3">
                <table className="table">
                  <tbody>
                    { invalidVouchers }
                  </tbody>
                </table>
              </TabPane>
              <TabPane tabId="4">
                <table className="table">
                  <tbody>
                    { storeOrderNumbers }
                  </tbody>
                </table>
              </TabPane>
              <TabPane tabId="5">
                <table className="table"> 
                  <tbody>
                    <tr>
                      <th>Referral code:</th>
                      <td>{ (user.referral && user.referral.voucherId) || "-" }</td>
                    </tr>
                    <tr>
                      <th>Campaign version:</th>
                      <td>{ (user.referral && user.referral.campaignVersion) || "-" }</td>
                    </tr>
                    <tr>
                      <th>Campaign name:</th>
                      <td>{ (user.referral && user.referral.campaignId) || "-" }</td>
                    </tr>
                  </tbody>
                </table>
              </TabPane>
              <TabPane tabId="6">
              <table className="table">
                  <tbody>
                    { activeVouchers }
                  </tbody>
                </table>
              </TabPane>
              <TabPane tabId="7">
                <table className="table"> 
                  <tbody>
                    { connections }
                  </tbody>
                </table>
              </TabPane>
            </TabContent>
          </div>
        </div>
      </div>
    );

    const loader = (
      <div className="col-md-12 card">
        <h2>Loading user...</h2>
      </div>
    );

    return (
      <Fragment>
        {
          this.state.loading
          ? loader
          : user.deleted
            ? deletedUserProfile
            : userProfile
        } 
    </Fragment>
    );
  }
}

export default UserInspector;
